import { ERROR_CODES } from '@ddt-web/config';
import { WweBenchmark } from '@ddt-web/domain';
import * as get from 'lodash/get';

import { SharedEngagementsConstants } from '../../constants/shared-engagements.constants';
import { BpasEngagement } from '../bpas-engagement.model';
import { EngagementsFlags } from '../engagements-flags.model';
import { EngagementResponse, EngagementsFlagsResponse, EngagementsListResponse } from '../responses/engagements-response.model';


export const mapFetchUserDataResponseToBpasEngagementList = (json: EngagementsListResponse) => {
	if (json.allDataReturned && json.success) {
		const results = json.resultMap[SharedEngagementsConstants.SEARCH_RESULTS_KEY] || json.resultMap[SharedEngagementsConstants.SEARCH_EDIT_RESULTS_KEY];

		const engagementsListResponse: EngagementResponse[] = results ? get(results, '[0].resultList', []) : [];
		return engagementsListResponse.map(engagementResponse => {
			return {
				children: engagementResponse.children ? engagementResponse.children : [],
				description: engagementResponse.description,
				flags: engagementResponse.flags ? mapEngagementsFlagsResponseToEngagementsFlags(engagementResponse.flags) : {},
				benchmarkDetails: engagementResponse.benchmarkDetails ? mapEngagementBenchmarkDetailsResponseToBenchmark(engagementResponse.benchmarkDetails) : {},
				origin: engagementResponse.origin,
				type: engagementResponse.type,
				uniqueId: engagementResponse.uniqueId,
				dateLastModified: engagementResponse.dateLastModified,
				currentUserIsOwner: engagementResponse.currentUserIsOwner,
				currency: engagementResponse.currency,
				lastModifiedDisplayDate: engagementResponse.lastModifiedDisplayDate
			} as BpasEngagement;
		});
	} else {
		throw new Error(ERROR_CODES.PAC_ERROR_CODES.PARSE_ENGAGEMENT_FAILURE);
	}
};

export const mapEngagementsFlagsResponseToEngagementsFlags = (json: EngagementsFlagsResponse) => {
	return {
		isActive: json.isActive
	} as EngagementsFlags;
};

export const mapEngagementBenchmarkDetailsResponseToBenchmark = (json: string) => {
	const benchmark: WweBenchmark = JSON.parse(json);
	return benchmark;
};

